module.exports = __webpack_public_path__ + "img/jm.070d42e5.png";